import axios from '../../../../utils/AxiosUtils';
import {
    GET_DELIVERY_PARTNERS,
    GET_RESTAURANT_DELIVERY_PARTNER_SETTINGS,
    LOADING,
    RESET_RESTAURANT_DELIVERY_PARTNER_SETTINGS
} from "../../../types";
import MessageUtils from "../../../../utils/MessageUtils";
import i18n from "../../../../i18next";

export const getDeliveryPartners = () => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/delivery-partner/`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: GET_DELIVERY_PARTNERS, payload: response.data })
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const getRestaurantDeliveryPartnerSettings = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/delivery-partner-settings`;

        axios().get(url)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: GET_RESTAURANT_DELIVERY_PARTNER_SETTINGS, payload: response.data })
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const saveRestaurantDeliveryPartnerSettings = (restaurantId, data) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/delivery-partner-settings`;

        axios().put(url, data)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const resetRestaurantDeliveryPartnerSettings = (restaurantId) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${restaurantId}/delivery-partner-settings/reset`;

        axios().put(url, {})
            .then(() => {
                dispatch({ type: LOADING, payload: false });
                dispatch({ type: RESET_RESTAURANT_DELIVERY_PARTNER_SETTINGS, payload: false });
            }
            ).catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const saveDeliveryZoneDeliveryPartnerSettings = (deliveryZoneId, data, loadDeliveryZones) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/delivery-zone/${deliveryZoneId}/delivery-partner-settings`;

        if (validateDeliveryPartnerSettings(data)) {
            return MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:deliveryActions.deliveryProviderSettingsEmpty'));
        }

        axios().put(url, data)
            .then(response => {
                dispatch({ type: LOADING, payload: false });
                loadDeliveryZones();
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:deliveryZonesActions.updateDeliveryZoneSuccess'));
            })
            .catch(error => {
                dispatch({ type: LOADING, payload: false });
                loadDeliveryZones();
                MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

const validateDeliveryPartnerSettings = (data) => {
    let hasEmptyValue = false;
    const parsedData = JSON.parse(data.settings);
    for (const key in parsedData) {
        if (!parsedData[key]) {
            return hasEmptyValue = true;
        }
    }
}

export const resetDeliveryZoneDeliveryPartnerSettings = (deliveryZoneId, loadDeliveryZones) => {
    return (dispatch) => {

        dispatch({ type: LOADING, payload: true });

        const url = `/delivery-zone/${deliveryZoneId}/delivery-partner-settings/reset`;

        axios().put(url, {})
            .then(() => {
                dispatch({ type: LOADING, payload: false });
                loadDeliveryZones()
                MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:deliveryZonesActions.updateDeliveryZoneSuccess'));
            }
            ).catch(error => {
                dispatch({ type: LOADING, payload: false });
                MessageUtils.errorMessageResponse(dispatch, i18n.t('actions:posSettings.commonFailure'));
            })
    }
};

export const invalidFormMessage = () => dispatch => {
    MessageUtils.errorMessageResponse(dispatch, '', i18n.t('screens:deliveryPartnerScreen.emptyFields'));
}


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/DeliveryProviderActions.js